// // src/utils/saveGoalToSheet.js
// export async function saveGoalToSheet(fullName, goal) {
//   try {
//     const response = await fetch("https://eof3blltz2t0gpz.m.pipedream.net", {
   
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         FullName: fullName,
//         Goal: goal,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error ${response.status}`);
//     }

//     const result = await response.json();
//     console.log("✅ Goal saved:", result);
//     return result;
//   } catch (error) {
//     console.error("❌ Error saving goal:", error);
//     throw error;
//   }
// }
export async function saveGoalToSheet(fullName, goal) {
  try {
    const now = new Date();
    
    // Format the date and time: YYYY-MM-DD HH:MM:SS
    const formattedTimestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

    const response = await fetch("https://eof3blltz2t0gpz.m.pipedream.net", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        FullName: fullName,
        Goal: goal,
        Timestamp: formattedTimestamp, // 👈 Use formatted timestamp
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    const result = await response.json();
    console.log("✅ Goal saved:", result);
    return result;
  } catch (error) {
    console.error("❌ Error saving goal:", error);
    throw error;
  }
}


